// this import was breaking jest
// import { presentSimpleAlert } from '../samosa/ui/components/simple-alert';

export const alertError = (error: any) => {
  console.error(error);
  // todo: report to sentry
  // presentSimpleAlert(String(error));
  window.alert(String(error));
};
